var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_search_48px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3333 9.33333H9.80333L9.62 9.15C10.2733 8.39333 10.6667 7.41 10.6667 6.33333C10.6667 3.94 8.72667 2 6.33333 2C3.94 2 2 3.94 2 6.33333C2 8.72667 3.94 10.6667 6.33333 10.6667C7.41 10.6667 8.39333 10.2733 9.15 9.62333L9.33333 9.80667V10.3333L12.6667 13.66L13.66 12.6667L10.3333 9.33333ZM6.33333 9.33333C4.67667 9.33333 3.33333 7.99 3.33333 6.33333C3.33333 4.67667 4.67667 3.33333 6.33333 3.33333C7.99 3.33333 9.33333 4.67667 9.33333 6.33333C9.33333 7.99 7.99 9.33333 6.33333 9.33333Z",
    fill: "#737C8A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.a537ece6161ab56a05f0d452c87413c8.svg";
export { ForwardRef as ReactComponent };